export default {
  skipToContent: 'Skip to content',
  lightMode: 'Light mode',
  darkMode: 'Dark mode',
  actions: 'Actions',
  bookingSheet: 'Booking Database',
  campaign: 'Campaign',
  campaignDates: 'Campaign dates',
  cancel: 'Cancel',
  channels: 'Channels',
  client: 'Client',
  close: 'Close',
  create: 'Create',
  creativeLibrary: 'Creative Library',
  dashboard: 'Dashboard',
  salesDashboard: 'Sales Dashboard',
  financialYearForecast: 'Financial Year Forecast',
  threeMonthForecast: 'Current Quarter Forecast',
  campaignMargins: 'Campaign Margins',
  date: 'Date',
  dealId: 'Deal ID',
  delete: 'Delete',
  edit: 'Edit',
  endDate: 'End Date',
  logout: 'Log Out',
  mediaPlan: 'Media Plans',
  io: 'IO',
  more: 'More',
  raiseIo: 'Raise IO',
  poNumberAction: 'PO number',
  noData: 'No Data',
  ioTemplates: 'IO Templates',
  rateCard: 'Rate Cards',
  reports: 'Reports',
  requiredFieldMessage: 'This field is required.',
  responsibleAM: 'Responsible AM',
  save: 'Save',
  scheduleDate: 'Schedule date',
  allocatedBudget: 'Allocated budget',
  send: 'Send',
  startDate: 'Start Date',
  status: 'Status',
  totalBudget: 'Total Budget',
  totalMargin: 'Total Gross Profit %',
  totalImpressions: 'Total Impressions',
  traderSheet: 'Trader Sheet',
  userSettings: 'User Settings',
  traderControls: 'Trader controls',
  traderControlsChannels: 'Channels',
  traderControlsDspFees: 'DSP fees',
  traderControlsKpis: 'KPIs',
  traderControlsTradingDeals: 'Trading deals',
  tradingDealsBuyingPointsTab: 'Buying points',
  tradingDealsChannelOverridesTab: 'Channel overrides',
  traderControlsTradingDealsDescription:
    'Manage rebate % by buying point. Channel overrides take precedence over the buying-point default when calculating media plan rebates.',
  requiresClientOrder: 'Client order required',
  requiresClientOrderHint:
    'This buying point signs its own order (Prisma or DocuSign). Bookings are held back from the booking database until the signed order is attached.',
  clientOrderRequired: 'Required',
  buyingPointName: 'Buying point',
  addTradingDeal: 'Add buying point',
  editTradingDeal: 'Edit buying point',
  deleteTradingDealModalTitle: 'Delete buying point',
  deleteTradingDealModalDescription: 'Are you sure you want to deactivate this buying point rebate?',
  tradingDealHasBeenCreated: 'Buying point rebate has been created.',
  tradingDealHasBeenEdited: 'Buying point rebate has been edited.',
  tradingDealHasBeenDeleted: 'Buying point rebate has been deactivated.',
  addTradingDealChannel: 'Add channel override',
  editTradingDealChannel: 'Edit channel override',
  deleteTradingDealChannelModalTitle: 'Delete channel override',
  deleteTradingDealChannelModalDescription:
    'Are you sure you want to delete this channel rebate override? This cannot be undone.',
  tradingDealChannelHasBeenCreated: 'Channel rebate override has been created.',
  tradingDealChannelHasBeenEdited: 'Channel rebate override has been edited.',
  tradingDealChannelHasBeenDeleted: 'Channel rebate override has been deleted.',
  kpi: 'KPI',
  benchmark: 'Benchmark',
  addKpi: 'Add KPI',
  editKpi: 'Edit KPI',
  deleteKpiModalTitle: 'Delete KPI',
  deleteKpiModalDescription: 'Are you sure you want to delete this KPI?',
  kpiHasBeenCreated: 'KPI has been created.',
  kpiHasBeenEdited: 'KPI has been edited.',
  kpiHasBeenDeleted: 'KPI has been deleted.',
  seedKpisFromRateCards: 'Seed from Rate Cards',
  kpisSeededFromRateCards: 'KPIs have been seeded from rate cards.',
  kpisSeedFailed: 'Failed to seed KPIs from rate cards.',
  kpisApiNotConfigured: 'KPIs API is not configured yet. Implement the backend endpoints (see BACKEND_KPI_SCHEMA.md) and use "Seed from Rate Cards" to populate.',
  kpisSeedFirst: 'No KPIs yet. Use "Seed from Rate Cards" to populate from existing rate cards.',
  skyriseRateBuilder: 'Skyrise Rate Builder',
  customPackage: 'Custom Packages',
  eu6Calculator: 'Rate Calculator',
  calculatorRateCard: 'Inventory',
  addCalculatorRate: 'Add rate',
  editCalculatorRate: 'Edit rate',
  calculatorRateCreated: 'Rate has been created.',
  calculatorRateUpdated: 'Rate has been updated.',
  calculatorRateDeleted: 'Rate has been deleted.',
  deleteCalculatorRateModalTitle: 'Delete rate',
  deleteCalculatorRateModalDescription: 'Are you sure you want to delete this inventory rate?',
  expectedMargin: 'Gross Profit %',
  grossMargin: 'Gross Margin',
  grossProfit: 'Gross Profit',
  grossMarginPercent: 'Gross Margin %',
  grossProfitPercent: 'Gross Profit %',
  grossMarginBeforeRebate: 'Gross Margin (Before Rebate)',
  grossProfitAfterRebate: 'Gross Profit (After Rebate)',
  blendedGrossMarginPercent: 'Blended Gross Margin %',
  blendedGrossProfitPercent: 'Blended Gross Profit %',
  blendedGrossProfit: 'Blended Gross Profit',
  rebate: 'Rebate',
  rebatePercent: 'Rebate %',
  saveAsPDF: 'Download',
  customPackagesTitle: 'Custom Packages',
  newPackage: 'New package',
  duplicate: 'Duplicate',
  duplicatePackage: 'Duplicate package',
  buildPackage: 'Build package',
  searchPackagesPlaceholder: 'Search by name, description, channel or format…',
  view: 'View',
  packageName: 'Name',
  packageBuyingPoint: 'Buying point',
  packageRebatePercent: 'Rebate %',
  channel: 'Channel',
  channelKey: 'Key',
  channelLabel: 'Label',
  addChannel: 'Add Channel',
  lineItemDefaults: 'New line item defaults',
  lineItemDefaultsHint: 'Prefilled when this channel is picked on a new line item. Traders can still change them.',
  defaultTargetingDetails: 'Default targeting details',
  defaultDsp: 'Default DSP',
  editChannel: 'Edit Channel',
  deleteChannelModalTitle: 'Delete Channel',
  deleteChannelModalDescription: 'Are you sure you want to delete this channel?',
  channelHasBeenCreated: 'Channel has been created.',
  channelHasBeenEdited: 'Channel has been edited.',
  channelHasBeenDeleted: 'Channel has been deleted.',
  seedChannelsFromRateCards: 'Seed from Rate Cards',
  channelsSeededFromRateCards: 'Channels have been seeded from rate cards.',
  channelsSeedFailed: 'Failed to seed channels from rate cards.',
  active: 'Active',
  inactive: 'Inactive',
  dspName: 'DSP Name',
  feePercentage: 'Fee %',
  addDspFee: 'Add DSP Fee',
  editDspFee: 'Edit DSP Fee',
  deleteDspFeeModalTitle: 'Delete DSP Fee',
  deleteDspFeeModalDescription: 'Are you sure you want to delete this DSP fee?',
  dspFeeHasBeenCreated: 'DSP fee has been created.',
  dspFeeHasBeenEdited: 'DSP fee has been edited.',
  dspFeeHasBeenDeleted: 'DSP fee has been deleted.',
  createdDate: 'Date Created',
  updatedAt: 'Updated At',
  updatedBy: 'Updated By',
  packageDeleted: 'Package deleted successfully.',
  packageSaveSuccess: 'Package saved successfully.',
  singleChannelError: 'Packages must contain a single channel. This package uses channel {{channel}}.',
  noRows: 'Add at least one rate line to save as package.',
  totalDeliveryExceeds100:
    'Total delivery exceeds 100%. Adjust the delivery percentages on your rate lines so they add up to 100% or less before saving.',
  saveAsPackage: 'Save as package',
  downloadPackagePdf: 'Download PDF',
  packagePdfDownloadFailed: 'Failed to download package PDF.'
} as Record<string, string>;
